export const ru = {
    'mc-banner-recommendation-text': 'Для сохранения группы укажите ключевые фразы',
    'performance-recommendation-text': 'Для сохранения группы заполните условия показов вручную',
    'tgo-recommendation-text': 'Для сохранения группы включите автотаргетинг или заполните условия показов вручную'
};
